import React, { useEffect, useState } from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { format, utcToZonedTime } from "date-fns-tz";
import { useSelector } from "react-redux";
import { StateProvider } from "../../../../components/SharedContext";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import "./key-events.m.css";

const KeyEventCard = (props) => {
  const { card = {}, story } = props;
  const { "story-elements": storyElements = [], id } = card;
  const { "card-event-at": cardAddedAt } = card;
  const firstTitleInCard = storyElements?.find((element) => element.type === "title");
  const timezone = useSelector((state) => get(state, ["qt", "data", "timezone"], "Asia/Kolkata"));

  const scrollToCard = (event) => {
    event.preventDefault();
    const cardToView = document.getElementById(`${story?.slug}-${id}`);
    cardToView.style.scrollMargin = "80px";
    cardToView.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
  };
  const getTimeStamp = (date) => {
    const zonedTime = utcToZonedTime(date, timezone);
    const formatZonedTime = zonedTime && format(zonedTime, "hh:mm a, d MMMM yyyy", { timeZone: timezone });
    return <time dateTime={formatZonedTime}>{formatZonedTime}</time>;
  };
  return (
    <div onClick={scrollToCard} styleName="highlights">
      <div styleName="timeline-bullet"></div>
      <div styleName="timeline-content">
        {firstTitleInCard && <span>{firstTitleInCard?.text}</span>}
        <p styleName="event-time-line">{getTimeStamp(cardAddedAt)}</p>
      </div>
    </div>
  );
};

KeyEventCard.propTypes = {
  card: PropTypes.shape({
    "card-added-at": PropTypes.number,
    "story-elements": PropTypes.array,
    id: PropTypes.string,
  }),
  slug: PropTypes.string,
  index: PropTypes.number,
};

const KeyEvents = ({ story = {} }) => {
  const cards = get(story, ["cards"], []);
  const initialLoadCount = 4;
  const [initialCount, updatedCount] = useState(initialLoadCount);
  const [keyEventCards, setKeyEventCards] = useState([]);

  const cardsWithKeyEvents = cards.filter((card) => get(card?.metadata, ["attributes", "key-event"]));
  const hasmore = cardsWithKeyEvents.length > initialCount;

  const handleClick = () => {
    updatedCount(initialCount + initialLoadCount);
  };

  if (cardsWithKeyEvents.length < 1) {
    return null;
  }

  useEffect(() => {
    setKeyEventCards(cardsWithKeyEvents.slice(0, initialCount));
  }, [initialCount, cards?.length]);

  return (
    <div styleName="events-container">
      <div styleName="timeline">
        {keyEventCards.map((card, source) => (
          <KeyEventCard cardLength={source.length} card={card} key={card.id} story={story} />
        ))}
      </div>
      {hasmore && (
        <div styleName="show-more-div" onClick={handleClick}>
          <SvgIconHandler
            type="point-arrow"
            iconStyle={{ color: "#303D43" }}
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
          />
          <span>SHOW MORE</span>
        </div>
      )}
    </div>
  );
};

KeyEvents.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  showLoadMore: PropTypes.bool,
};

export default StateProvider(KeyEvents);
